export enum ImageTypeDimentions {
    SQUARE_WIDTH = 160,
    SQUARE_HEIGHT = 160,
    BACKGROUND_WIDTH = 729,
    BACKGROUND_HEIGHT = 160
}